import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: "Bataaxal bu gudde nii",
      cover:
      "/images/bataaxal.PNG",
      artist: "Mariyaama Ba",
      audio: "https://firebasestorage.googleapis.com/v0/b/teerey-af4b2.appspot.com/o/bataxal.mp3?alt=media&token=53ae883d-bb34-4e70-80a5-c7936a43de30",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Alxuraan Ak Xamtu",
      cover:
      "/images/AlxuraanAkXamtu.png",
      artist: "Wolof Ak Xamle",
      audio: "https://firebasestorage.googleapis.com/v0/b/teerey-af4b2.appspot.com/o/alquraan.mp3?alt=media&token=302a4bc2-0575-4ada-a691-0f0e2ac415c7",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Jinney Jullit Ji 1",
      cover:
      "/images/jinne.png",
      artist: "Nit la",
      audio: "https://firebasestorage.googleapis.com/v0/b/teerey-af4b2.appspot.com/o/jinne1.mp3?alt=media&token=2e2756e7-6af6-40dd-a14f-bd1b7b0ed08b",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Jinney Jullit Ji 2",
      cover:
        "/images/jinne.png",
      artist: "Wolof Ak Xamle",
      audio: "https://firebasestorage.googleapis.com/v0/b/teerey-af4b2.appspot.com/o/jinne2.mp3?alt=media&token=09ffe8ff-1cd6-450b-8112-d37f52de3153",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Jinney Jullit Ji 3",
      cover:
      "/images/jinne.png",
      artist: "Wolof Ak Xamle",
      audio: "https://firebasestorage.googleapis.com/v0/b/teerey-af4b2.appspot.com/o/jinne3.mp3?alt=media&token=5f7345aa-f2a5-422a-899f-c0247668918d",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Jinney Jullit Ji 4",
      cover:
      "/images/jinne.png",
      artist: "Wolof Ak Xamle",
      audio: "https://firebasestorage.googleapis.com/v0/b/teerey-af4b2.appspot.com/o/jinne4.mp3?alt=media&token=94c9667e-19b0-4f3d-928e-c0c14fe088a0",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    //ADD MORE HERE
  ];
}

export default chillHop;
